import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";
import { Skeleton } from "@/components/ui/skeleton";

export function AuthGuard() {
  const { user, loading, pendingQuestionnaire, pendingReferral } = useAuth();

  if (loading || (user && (pendingQuestionnaire === null || pendingReferral === null))) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Skeleton className="h-10 w-10 rounded-full" />
          <Skeleton className="h-4 w-32" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (pendingReferral === true) {
    return <Navigate to="/referral" replace />;
  }

  if (pendingQuestionnaire === true) {
    return <Navigate to="/questionnaire" replace />;
  }

  return <Outlet />;
}
